import DesignSystemButton from '../../components/Button/DesignSystemButton';
import Loading from '../../components/Loading/Loading';
import React from 'react';
import Show from '../../components/Show/Show';
import { ERROR_COLOR } from '../../config/designSystem/Colors';
import { H1, ParagraphLRegular, ParagraphMRegular, ParagraphSBold } from '../../config/designSystem/typography';
import { LanguagePicker } from '../../components/ChangeLanguage/ChangeLanguage';
import { ScrollView, View } from 'react-native';
import { TermsAndConditions } from '../../components/TermsAndConditions/TermsAndConditions';
import { branchingKey, sessionStackKey } from '../../constants/routeKeys';
import { captureException } from '@sentry/react-native';
import { concatPath } from '../../utils/links/concatPath';
import { observer } from 'mobx-react';
import { router, useGlobalSearchParams } from 'expo-router';
import { useChangeLanguage } from '../../hooks/useChangeLanguage';
import { useStores } from '../../hooks/useStores';


const AnonymousReckoningPresentation = observer(() => {
  const rootStore = useStores();

  const labels = rootStore?.language.translate.MOBILE?.SESSION?.RECKONING_PRESENTATION;
  const [checked, setChecked] = React.useState(false);
  const [status, setStatus] = React.useState('ok');
  const changeLanguage = useChangeLanguage();
  const [language, setLanguage] = React.useState(rootStore?.language?.name?.key);
  const params = useGlobalSearchParams();
  const reckoning = rootStore.reckoning.getReckoning(params.reckoningId as string);

  const reckoningSessionId = reckoning?.session;
  const label = reckoning?.explanationForAnonymousUser;

  React.useEffect(()=> {
    setLanguage(rootStore?.language?.name?.key);
    rootStore.reckoning.fetchReckoning(params.reckoningId as string, true);
  }, [rootStore?.language?.name?.key]);

  // Only change the language on an actual user selection — not on mount, which
  // would re-apply the current language and fire a spurious request.
  const onSelectLanguage = (value: string) => {
    setLanguage(value);
    changeLanguage(value);
  };



  const goToReckoning = async () => {
    if(!reckoning?._id || !reckoningSessionId) {
      captureException(new Error('No reckoningId or reckoningSessionId in storage'));
    }
    router.navigate({
      pathname: concatPath([sessionStackKey, branchingKey]) as string,
      params: {
        fromReckoning: 'true',
        reckoningId: reckoning?._id,
        sessionId: reckoningSessionId
      }
    });
  };

  return (
    <ScrollView style={{flex:1, backgroundColor:'whitesmoke', padding: 20}} contentContainerStyle={{justifyContent:'space-between'}}>
      <View style={{marginTop:30}}>
        <View >
          <H1>
            {labels?.TITLE}
          </H1>
        </View>
        <Show when={rootStore.reckoning.state === 'done'} fallback={<Loading />}>
          <View style={{marginTop: 30}}>
            <ParagraphLRegular >
              {label}
            </ParagraphLRegular>
          </View>
        </Show>
      </View>
      <View >
        <View>
          <ParagraphMRegular>
            {labels?.CHANGE_LANGUAGE}
          </ParagraphMRegular>
        </View>
        <View style={{justifyContent:'center'}}>
          <LanguagePicker language={language} changeLanguage={onSelectLanguage} />
        </View>
      </View>
      <View>

        <TermsAndConditions accepted={checked} setAccepted={setChecked}  />

        <View style={ {marginVertical: 10,
          marginHorizontal: 25}}>
          {status === 'notChecked' && (
            <ParagraphSBold color={ERROR_COLOR}
            >
              {labels?.PLEASE_AGREE_TO_TERMS}
            </ParagraphSBold>)}
        </View>


        <DesignSystemButton  label={labels?.BUTTON} onPress={()=> {
          if(checked) {
            rootStore?.user.setGDPRAccepted();
            goToReckoning();
          } else {
            setStatus('notChecked');
          }
        }}/>
      </View>
    </ScrollView>
  );
});

export default AnonymousReckoningPresentation;
